<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Resumen Factura</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="divtotal">
          <div class="texttotal">{{datamodalcashback.name}}</div>
          <div class="numerototal fontMono has-text-right">
            <span>{{datamodalcashback.valor | number(2)}}</span>
          </div>
        </div>
        <div class="divtotal">
          <div class="texttotal">Efectivo</div>
          <div class="numeroinput">
            <input
              class="input is-static has-text-right fontMono"
              id="valormodalcashback"
              type="number"
              placeholder="Valor"
              v-model="valor"
              @keydown="keyfunction($event)"
            />
          </div>
        </div>

        <div class="has-text-centered">
          <strong>Cambio:</strong>
          <br />
          <span class="fontMono cambio">{{cambio | number(2)}}</span>
        </div>

        <!-- Content ... -->
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-large"
          id="printcashback"
          @click="print"
          @keydown="keyfunctionprint($event)"
        >
          <span class="icon is-small">
            <span class="material-icons">print</span>
          </span>
          <span>Imprimir</span>
        </button>
        <button class="button is-large" id="savecashback" @keydown="keyfunctionsave($event)" @click="save">
          <span class="icon is-small">
            <span class="material-icons">save</span>
          </span>
          <span>Guardar</span>
        </button>
        <button
          class="button is-warning is-large"
          @click="close"
          id="cancelcashback"
          @keydown="keyfunctioncancel($event)"
        >
          <span class="icon is-small">
            <span class="material-icons">cancel</span>
          </span>
          <span>Cancelar</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valor: "",
    };
  },
  props: {
    show: Boolean,
    datamodalcashback: Object,
  },
  computed: {
    cambio() {
      return parseFloat(this.valor) - this.datamodalcashback.valor;
    },
  },
  methods: {
    save() {
      const response = {
        status: 'save',
        cashback: this.cambio,
        cash: parseFloat(this.valor)
      };
      this.$emit('responsemodalcashback',response);
    },
    print() {
      const response ={
        status: 'print',
        cashback: this.cambio,
        cash: parseFloat(this.valor)
      };
      this.$emit('responsemodalcashback',response);
    },
    close() {
      this.$emit("showmodalcashback", false);
    },
    keyfunction(e) {
      console.log(e.keyCode);
      if (e.keyCode === 121) {
        // presiona la tecka f10
        e.preventDefault();
        this.$emit("f10guardar");
      }
      if (e.keyCode === 13 || e.keyCode === 9 || e.keyCode === 40) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("printcashback").focus();
      }
      if(e.keyCode === 27){
        this.close();
      }
    },
    keyfunctionprint(e) {
      console.log(e.keyCode);
      if (e.keyCode === 121) {
        // presiona la tecka f10
        e.preventDefault();
        this.$emit("f10guardar");
      }
      if (e.keyCode === 38) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("valormodalcashback").focus();
        document.getElementById("valormodalcashback").select();
      }
      if (e.keyCode === 39) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("savecashback").focus();
      }
      if(e.keyCode === 27){
        this.close();
      }
    },
    keyfunctionsave(e) {
      console.log(e.keyCode);
      if (e.keyCode === 38) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("valormodalcashback").focus();
        document.getElementById("valormodalcashback").select();
      }
      if (e.keyCode === 37) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("printcashback").focus();
      }
      if (e.keyCode === 39) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("cancelcashback").focus();
      }
      if(e.keyCode === 27){
        this.close();
      }
    },
    keyfunctioncancel(e) {
      console.log(e.keyCode);
      if (e.keyCode === 38) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("valormodalcashback").focus();
        document.getElementById("valormodalcashback").select();
      }
      if (e.keyCode === 37) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        document.getElementById("savecashback").focus();
      }
      if(e.keyCode === 27){
        this.close();
      }
    },
  },
  watch: {
    show(nv, ov) {
      if (nv) {
        this.valor = "";
        setTimeout(function () {
          document.getElementById("valormodalcashback").focus();
        }, 10);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.divtotal {
  width: 100%;
  margin-bottom: 15px;
  height: 38px;
}
.texttotal {
  background-color: whitesmoke;
  padding: 6px 0px 6px 12px;
  width: 50%;
  border-left: 4px solid whitesmoke;
  border-bottom: 4px solid whitesmoke;
  border-top: 4px solid whitesmoke;
  color: #7a7a7a;
  float: left;
  border-radius: 4px 0px 0px 4px;
}
.numerototal {
  border: 4px solid whitesmoke;
  padding: 6px 12px 6px 0px;
  width: 50%;
  color: #7a7a7a;
  float: left;
  border-radius: 0px 4px 4px 0px;
}
.numeroinput {
  border: 4px solid whitesmoke;
  width: 50%;
  color: #7a7a7a;
  float: left;
  border-radius: 0px 4px 4px 0px;
}
.cambio {
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/modals/Modalcashback.vue